import React, { useEffect, useRef, useState } from 'react';

const LazyMap = () => {
  const containerRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '200px', threshold: 0.1 }
    );

    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        width: '100%',
        height: '250px',
        borderRadius: '8px',
        overflow: 'hidden',
        background: '#f0f0f0',
      }}
    >
      {visible && (
        <iframe
          title="Dubai Police Academy Map"
          width="100%"
          height="250"
          style={{ border: 0, borderRadius: '8px' }}
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3610.277369631658!2d55.191717!3d25.1234556!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f6bafeddb9ed9%3A0xeac9c34d14dc92ef!2sDubai%20Police%20Academy!5e0!3m2!1sen!2sae!4v1690000000000!5m2!1sen!2sae"
        ></iframe>
      )}
    </div>
  );
};

export default LazyMap;
